import { render, staticRenderFns } from "./file-element.vue?vue&type=template&id=682df4ed&scoped=true&"
import script from "./file-element.vue?vue&type=script&lang=js&"
export * from "./file-element.vue?vue&type=script&lang=js&"
import style0 from "./file-element.vue?vue&type=style&index=0&id=682df4ed&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682df4ed",
  null
  
)

export default component.exports